import { render, staticRenderFns } from "./SeguiView.vue?vue&type=template&id=2d78b710&scoped=true"
import script from "./SeguiView.vue?vue&type=script&lang=js"
export * from "./SeguiView.vue?vue&type=script&lang=js"
import style0 from "./SeguiView.vue?vue&type=style&index=0&id=2d78b710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d78b710",
  null
  
)

export default component.exports